import React, { useEffect, useRef } from 'react';

export default function InvoiceDialog({ title, onClose, busy = false, children }) {
  const panel = useRef(null);
  const closing = useRef({ onClose, busy });
  closing.current = { onClose, busy };
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.current.focus();
    const handleKey = event => {
      if (event.key === 'Escape' && !closing.current.busy) closing.current.onClose();
      if (event.key !== 'Tab') return;
      const targets = [...panel.current.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')]
        .filter(element => !element.matches(':disabled') && !element.hidden);
      const first = targets[0]; const last = targets[targets.length - 1];
      if (!first) { event.preventDefault(); panel.current.focus(); }
      else if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel.current)) {
        event.preventDefault(); first.focus();
      }
    };
    const current = panel.current;
    current.addEventListener('keydown', handleKey);
    return () => {
      current.removeEventListener('keydown', handleKey);
      document.body.style.overflow = overflow;
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-2 md:p-6">
    <section ref={panel} role="dialog" aria-modal="true" aria-label={title} tabIndex={-1}
      className="w-full max-w-5xl max-h-[92vh] overflow-y-auto bg-white rounded-xl shadow-xl p-4 md:p-6">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h2 className="text-xl font-semibold">{title}</h2>
        <button type="button" disabled={busy} onClick={onClose} className="border px-3 py-1 rounded disabled:opacity-50">Close</button>
      </div>
      {children}
    </section>
  </div>;
}
